import React from 'react';

import {ACTIONS} from './constants';
import type {State} from './reducer';

export type Action =
	| {type: typeof ACTIONS.SET_ACTIVE_ITEM; activeIndex: State['activeIndex']}
	| {type: typeof ACTIONS.SET_ACTIVE; active: State['active']}
	| {type: typeof ACTIONS.DISABLE}
	| {type: typeof ACTIONS.ENABLE}
	| {type: typeof ACTIONS.END}
	| {type: typeof ACTIONS.HOME}
	| {type: typeof ACTIONS.NEXT_ITEM}
	| {type: typeof ACTIONS.NEXT_PAGE}
	| {type: typeof ACTIONS.PREV_ITEM}
	| {type: typeof ACTIONS.PREV_PAGE}
	| {type: typeof ACTIONS.SET_PAGE_SIZE; pageSize: State['pageSize']}
	| {type: typeof ACTIONS.SET_TOTAL; total: State['total']}
	| {
			type: typeof ACTIONS.SET_INTERACTING_WITH_ITEM;
			interactingWithItem: State['interactingWithItem'];
	  };

export const Actions = (dispatch: React.Dispatch<Action>) => ({
	disable: () => dispatch({type: ACTIONS.DISABLE}),
	enable: () => dispatch({type: ACTIONS.ENABLE}),
	end: () => dispatch({type: ACTIONS.END}),
	home: () => dispatch({type: ACTIONS.HOME}),
	nextItem: () => dispatch({type: ACTIONS.NEXT_ITEM}),
	nextPage: () => dispatch({type: ACTIONS.NEXT_PAGE}),
	prevItem: () => dispatch({type: ACTIONS.PREV_ITEM}),
	prevPage: () => dispatch({type: ACTIONS.PREV_PAGE}),

	setActive: (active: State['active']) =>
		dispatch({type: ACTIONS.SET_ACTIVE, active}),
	setActiveIndex: (activeIndex: State['activeIndex']) =>
		dispatch({type: ACTIONS.SET_ACTIVE_ITEM, activeIndex}),
	setInteractingWithItem: (interactingWithItem: State['interactingWithItem']) =>
		dispatch({type: ACTIONS.SET_INTERACTING_WITH_ITEM, interactingWithItem}),
});

export default Actions;
